import type { SVGProps } from "react";

export default function SquarePlusIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.33327 8.00026C1.33327 4.85756 1.33327 3.28621 2.30958 2.3099C3.28589 1.33359 4.85723 1.33359 7.99993 1.33359C11.1426 1.33359 12.714 1.33359 13.6903 2.3099C14.6666 3.28621 14.6666 4.85756 14.6666 8.00026C14.6666 11.1429 14.6666 12.7143 13.6903 13.6906C12.714 14.6669 11.1426 14.6669 7.99993 14.6669C4.85723 14.6669 3.28589 14.6669 2.30958 13.6906C1.33327 12.7143 1.33327 11.1429 1.33327 8.00026Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10.0001 8.00014H6.0001M8.0001 6.00014V10.0001"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
